module.exports = __webpack_public_path__ + "static/circle_5-e036aa8c8e846a293484f80ab2972238.png";